import { render } from "./ViewMyRestaurants.vue?vue&type=template&id=00f520d2&scoped=true"
import script from "./ViewMyRestaurants.vue?vue&type=script&lang=js"
export * from "./ViewMyRestaurants.vue?vue&type=script&lang=js"

import "./ViewMyRestaurants.vue?vue&type=style&index=0&id=00f520d2&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f520d2"]])

export default __exports__